import {Link} from 'react-router-dom';

function Footer() {
  return (
    <div className="text-xl bg-[#231374] mt-10 text-center md:text-left">
        
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[3fr_1fr_1fr_1fr] gap-4 pt-20 pb-10 text-white">
          <div className="">
            <div className="text-2xl font-bold mb-4 text-white"> Repo<span className="text-[#985ff8]">Findr</span></div>
            <div className="font-semibold text-base px-[10%] md:px-0 lg:w-[80%]">
              A platform aimed at helping you find the open source project that is the perfect fit for you.
            </div>
          </div>

          <div className="mt-10 md:mt-0">
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="text-base font-semibold space-y-3">
              <li>
                <Link to="/" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Home 
                </Link>
              </li>

              <li>
                <Link to="/projects" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Projects
                </Link>
              </li>

              <li>
                <Link to="/privacy" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Privacy
                </Link>
              </li>

              <li>
                <Link to="/terms_&_conditions" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          <div className="mt-10 md:mt-0">
            <h4 className="font-semibold mb-4">Links</h4>
            <ul className="text-base font-semibold space-y-3">
              <li>
                <Link to="/communities" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Communities 
                </Link>
              </li>

              <li>
                <Link to="/blog_posts" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Blog 
                </Link>
              </li>

              <li>
                <Link to="/how_to" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Getting Started
                </Link>
              </li>

              <li>
                <Link to="/resources" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Resources
                </Link>
              </li>
              
            </ul>
          </div>

          <div className="mt-10 md:mt-0">
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="text-base font-semibold space-y-3">
              <li>
                <Link to="/report_bug" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Report a bug 
                </Link>
              </li>

              <li>
                <Link to="/report_bug" className="hover:text-[#985ff8] hover:cursor-pointer">
                  Customer Support 
                </Link>
              </li>
              
              <li>
                <Link to="/FAQ" className="hover:text-[#985ff8] hover:cursor-pointer">
                  FAQ 
                </Link>
              </li>
            </ul>
            <ul>
              <li> </li>
            </ul>
          </div>
        </div>

        <div className="container mx-auto border-t border-white text-white font-semibold text-base text-center pt-8 leading-8">
          <p> &copy; {new Date().getFullYear()} Open Source Findr. All rights reserved. </p>
          {/* Developed by <br/>
          <span className="text-[#985ff8]">Chinaza Chukwunweike</span> */}
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <defs>
            <linearGradient id="waveGradient" gradientTransform="rotate(135)">
              <stop offset="0%" stop-color="hsl(250, 95%, 63%)" />
              <stop offset="100%" stopColor="hsl(270, 90%, 70%)" />
            </linearGradient>
          </defs>
          <path 
            fill="url(#waveGradient)" 
            fillOpacity="1" 
            d="M0,192L6.7,165.3C13.3,139,27,85,40,74.7C53.3,64,67,96,80,133.3C93.3,171,107,213,120,192C133.3,171,147,85,160,96C173.3,107,187,213,200,256C213.3,299,227,277,240,272C253.3,267,267,277,280,282.7C293.3,288,307,288,320,272C333.3,256,347,224,360,192C373.3,160,387,128,400,144C413.3,160,427,224,440,224C453.3,224,467,160,480,138.7C493.3,117,507,139,520,149.3C533.3,160,547,160,560,176C573.3,192,587,224,600,224C613.3,224,627,192,640,186.7C653.3,181,667,203,680,224C693.3,245,707,267,720,256C733.3,245,747,203,760,181.3C773.3,160,787,160,800,170.7C813.3,181,827,203,840,202.7C853.3,203,867,181,880,197.3C893.3,213,907,267,920,266.7C933.3,267,947,213,960,202.7C973.3,192,987,224,1000,240C1013.3,256,1027,256,1040,240C1053.3,224,1067,192,1080,154.7C1093.3,117,1107,75,1120,96C1133.3,117,1147,203,1160,234.7C1173.3,267,1187,245,1200,208C1213.3,171,1227,117,1240,85.3C1253.3,53,1267,43,1280,69.3C1293.3,96,1307,160,1320,170.7C1333.3,181,1347,139,1360,138.7C1373.3,139,1387,181,1400,197.3C1413.3,213,1427,203,1433,197.3L1440,192L1440,320L0,320Z">
          </path>
        </svg>

    </div>
  );
}

export default Footer;
